export default __webpack_public_path__ + "static/media/obras.7796298b.jpeg";